<div class="flex justify-between items-center">
    <button class="text-true-blue sm:w-20" mat-icon-button [matMenuTriggerFor]="menu" #t="matMenuTrigger"
        aria-label="menu drop down">
        <div class="hidden sm:inline text-base text-true-blue font-denim-semibold">MENU </div>
        <mat-icon *ngIf="!t.menuOpen" class="text-true-blue" svgIcon="menu"></mat-icon>
        <mat-icon *ngIf="t.menuOpen" class="text-true-blue" svgIcon="close"></mat-icon>
    </button>
    <mat-menu #menu="matMenu" panelClass="menu-red" class="menu-dropdown opacity-90">
        <div class="flex flex-col justify-end bg-white">
            <div *ngIf="isBroker">
                <button class="flex justify-end items-center pt-2" mat-menu-item>
                    <button mat-button color="accent" (click)="onBrokerClick()">BROKER</button>
                </button>
            </div>
            <button class="flex justify-end items-center pt-2" mat-menu-item>
                <button mat-button color="accent" (click)="onFavoritesClick()">FAVORITES</button>
            </button>
            <button class="flex justify-end items-center" mat-menu-item>
                <button mat-button color="accent" (click)="onTourClick()">SCHEDULED TOURS</button>
            </button>
            <button class="flex justify-end items-center" mat-menu-item>
                <button mat-button color="accent" (click)="onDashboardHomeClick()">HOMES APPLIED FOR</button>
            </button>
            <button *ngIf="isResident" class="flex justify-end items-center" mat-menu-item>
                <button mat-button color="accent" (click)="onLeaseClick()">RESIDENT DOCUMENTS</button>
            </button>
            <button *ngIf="!isResident" disabled="true" class="flex justify-end items-center" mat-menu-item>
                <button mat-button color="disabled" class="p-0 text-right">RESIDENT DOCUMENTS</button>
            </button>
            <button *ngIf="isResident" class="flex justify-end items-center" mat-menu-item>
                <button mat-button color="accent" (click)="onRenewalClick()">RENEWAL OFFERS</button>
            </button>
            <button *ngIf="!isResident" disabled="true" class="flex justify-end items-center" mat-menu-item>
                <button mat-button color="disabled" class="p-0 text-right">RENEWAL OFFERS</button>
            </button>
            <button *ngIf="isResident" class="flex justify-end items-center" mat-menu-item>
                <button mat-button color="accent" (click)="onMaintenanceClick()">MAINTENANCE</button>
            </button>
            <button *ngIf="!isResident" disabled="true" class="flex justify-end items-center" mat-menu-item>
                <button mat-button color="disabled" class="p-0 text-right">MAINTENANCE</button>
            </button>
            <button class="flex justify-end items-center pb-2" mat-menu-item>
                <button mat-button color="accent" (click)="onSmartHomeClick()">SMART HOME</button>
            </button>
        </div>
        <div class="flex flex-col justify-end bg-true-blue text-white">
            <button class="flex justify-end items-center pt-2" mat-menu-item>
                <button mat-button color="white" (click)="onAccountClick()">MANAGE ACCOUNT</button>
            </button>
            <button class="flex justify-end items-center mb-2" mat-menu-item>
                <button mat-button color="white" (click)="onSignOutClick()">SIGN OUT</button>
            </button>
        </div>
    </mat-menu>
</div>
